import { ELanguage } from '@portals/help-center-core';
import { ECountries, ELocales } from '@/_types';

export const ICON_URL =
  'https://static-basket-02.wbbasket.ru/vol20/root-monorepo/latest/favicon.ico';

export const COUNTRIES_MAP: Record<ELocales, ECountries> = {
  [ELocales.RU]: ECountries.RU,
  [ELocales.EN]: ECountries.EN,
  [ELocales.KA]: ECountries.GE,
  [ELocales.ZH]: ECountries.CN,
  [ELocales.TR]: ECountries.TR,
  [ELocales.KK]: ECountries.KZ,
  [ELocales.TG]: ECountries.TJ,
};

export const LOCALE_LANGUAGE_MAP: Record<ELocales, ELanguage> = {
  [ELocales.RU]: ELanguage.RUSSIAN,
  [ELocales.EN]: ELanguage.ENGLISH,
  [ELocales.ZH]: ELanguage.CHINESE_CORRECT,
  [ELocales.KA]: ELanguage.GEORGIAN,
  [ELocales.TR]: ELanguage.TURKISH,
  [ELocales.KK]: ELanguage.KAZAKH,
  [ELocales.TG]: ELanguage.TAJIK,
};
